import React from "react";
import {filtersMapService} from "../jwt/_services/clasificator/filtersMapService";

export const filtersMapProvider = {
	getOptions,
	getItem,
};

async function getOptions(_dataFilter) {
	try {
		const listItems = await filtersMapService.search(0, 1000, _dataFilter);
		return listItems.data.map((item) => {
			return (
				{
					id: item.id,
					value: item.code,
					label: <label>{ item.code.toUpperCase() + ' - '  } <b>{ item.name }</b> </label>
				}
			)
		});
	} catch (error) {
		console.log(error.message)
	}
}

async function getItem(id) {
	try {
		const item = await filtersMapService.getItem(id);

		return (
			{
				id: item.id,
				value: item.code,
				label: <div><label>{item.name !== '' ? item.code + ' - ' + item.name : item.code }</label></div>
			}
		);
	} catch (error) {
		console.log(error.message)
	}
}